const colors = {
  brightBlue: '#0062ff',
  blueish: '#1162FB',
  white: '#ffffff',
  dark: '#2e3c4b',
  darkThree: '#272a3f',
  battleshipGrey: '#74797e',
  grey: '#E5E5E5',
  black10: '#0000001a',
  black08: '#00000008',
  whiteSeven: '#F4F7FA',
  red: '#C10C0C',
  appleGreen: '#53AC12'
}

export default colors
